module.exports = __webpack_public_path__ + "static/media/weekly-statistics-icon.4ff8b57d.svg";